export const styles = {
  container:
    "pt-hyam-navbar-h-sm xl:pt-hyam-navbar-h-xl h-fit",
};

export type HyamPrismicDocumentHomePageStyles =
  typeof styles;
